module.exports = __webpack_public_path__ + "ir.svg?1a62e10d6cfe077c86a38c4c5e8215e5";


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-flag-icon/node_modules/flag-icon-css/flags/1x1/ir.svg
// module id = 1425
// module chunks = 0